// extracted by mini-css-extract-plugin
module.exports = {"camp-C":"C_camp-C__J3bG6"};